<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 15.91" class="icon">
        <title>menu</title>
        <line x1="0.75" y1="0.75" x2="24.25" y2="0.75"
              style="fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/>
        <line x1="0.75" y1="7.96" x2="24.25" y2="7.96"
              style="fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/>
        <line x1="0.75" y1="15.16" x2="24.25" y2="15.16"
              style="fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/>
    </svg>
</template>

<script>
    export default {
        name: "IconMenu"
    }
</script>
